export default {
  SET_MODULES(state, modules) {
    state.modules = modules
  },
  SET_TAGS(state, tags) {
    state.tags = tags
  },
}
